import EmptyState from './EmptyState';
import EmptyStateContainer from './EmptyState.container';

export default EmptyStateContainer(EmptyState);
